import React from 'react'
import NotAvailable from './NotAvailable'
import SubTitle from './SubTitle'
import { educationIcon } from './Icons'
import CardView from './CardView'

const Education = ({ Education }) => {
    return (
        <>
            <SubTitle title="Education" titleIcon={educationIcon} />
            {
                Education.length === 0 ? <NotAvailable /> :
                    Education.map((educationObj, index) =>
                        <CardView key={index} cardObj={educationObj} />)
            }
        </>
    )
}

export default Education